import {ParentPay} from '~/modules/api/api.types';
import {EntitlementPaidLine} from './EntitlementPaidLine';
import {EntitlementPurchaseTags} from './EntitlementPurchaseTags';

interface ActiveEntitlementProps {
  entitlement: ParentPay.EntitlementDetail;
}

/**
 * One of the user's active entitlements, with its renewal details
 */
export const ActiveEntitlement = ({entitlement}: ActiveEntitlementProps) => (
  <div className="border-b border-base-200 pb-2 last:border-0 last:pb-0">
    <div className="flex items-center gap-2">
      <p className="font-medium">{entitlement.entitlement}</p>
      <EntitlementPurchaseTags entitlement={entitlement} />
    </div>
    <EntitlementPaidLine webPurchase={entitlement.webPurchase} />
    <p className="text-sm text-gray-600 break-words">
      <span className="font-bold">Plan:</span> {entitlement.planIdentifier}
    </p>
    {entitlement.billingInterval && (
      <p className="text-sm text-gray-600">
        <span className="font-bold">Billing:</span>{' '}
        {entitlement.billingInterval}
      </p>
    )}
    {entitlement.renewalDetails && (
      <>
        <p className="text-sm text-gray-600">
          <span className="font-bold">Next renewal:</span>{' '}
          {entitlement.renewalDetails.nextRenewalAt}
        </p>
        <p className="text-sm text-gray-600">
          <span className="font-bold">Auto-renew:</span>{' '}
          {entitlement.renewalDetails.autoRenewEnabled ? 'Yes' : 'No'}
        </p>
        <p className="text-sm text-gray-600">
          <span className="font-bold">Free trial ends:</span>{' '}
          {entitlement.renewalDetails.freeTrialEndsAt ?? '-'}
        </p>
      </>
    )}
  </div>
);
